( function () {
	'use strict';

	// ── Scroll-tilt helpers ───────────────────────────────────────────────────

	function runTiltEntrance( slide, targetDeg, layout ) {
		const quote = slide.querySelector( '.quote' );
		if ( ! quote ) return;

		quote.style.transition = 'none';
		quote.style.opacity    = '0';
		quote.style.transform  = `translateY(40px) rotate(0deg)`;

		void quote.offsetHeight;

		let rafId      = null;
		let hasEntered = false;

		function getProgress() {
			const rect = layout.getBoundingClientRect();
			const winH = window.innerHeight;
			const raw  = ( winH - rect.top ) / ( winH * 0.7 );
			return Math.min( 1, Math.max( 0, raw ) );
		}

		function easeOut( t ) {
			return 1 - Math.pow( 1 - t, 3 );
		}

		function tick() {
			const p   = easeOut( getProgress() );
			const y   = 40 * ( 1 - p );
			const rot = targetDeg * p;
			const op  = p;

			quote.style.transform = `translateY(${ y }px) rotate(${ rot }deg)`;
			quote.style.opacity   = op;

			if ( p < 1 ) {
				rafId = requestAnimationFrame( tick );
			} else {
				window.removeEventListener( 'scroll', onScroll, { passive: true } );
				quote.style.transform = `rotate(${ targetDeg }deg)`;
				quote.style.opacity   = '1';
				hasEntered = true;
			}
		}

		function onScroll() {
			if ( rafId ) cancelAnimationFrame( rafId );
			rafId = requestAnimationFrame( tick );
		}

		const io = new IntersectionObserver(
			function ( entries ) {
				entries.forEach( function ( entry ) {
					if ( ! entry.isIntersecting || hasEntered ) return;
					window.addEventListener( 'scroll', onScroll, { passive: true } );
					tick();
				} );
			},
			{ threshold: 0.05 }
		);

		io.observe( layout );
	}

	// ── Slider init ───────────────────────────────────────────────────────────

	function initSlider( el ) {
		const slides  = el.querySelectorAll( '.ts__slide' );
		const dots    = el.querySelectorAll( '.ts__dot' );
		const prevBtn = el.querySelector( '.ts__prev' );
		const nextBtn = el.querySelector( '.ts__next' );

		if ( ! slides.length ) return;

		let current = 0;
		const total = slides.length;

		const rotationAttr = el.dataset.tsRotation;
		const targetDeg    = rotationAttr ? parseFloat( rotationAttr ) : null;
		const hasTilt      = targetDeg !== null && ! isNaN( targetDeg );

		// ── Fix track height to tallest slide ─────────────────────────────────
		function fixTrackHeight() {
			const trackClip = el.querySelector( '.ts__track-clip' );
			if ( ! trackClip ) return;

			// Temporarily override all slides to measure naturally
			slides.forEach( function ( slide ) {
				slide.style.position   = 'relative';
				slide.style.visibility = 'hidden';
				slide.style.opacity    = '0';
				slide.style.pointerEvents = 'none';
			} );

			trackClip.style.height = '';

			let maxH = 0;
			slides.forEach( function ( slide ) {
				maxH = Math.max( maxH, slide.offsetHeight );
			} );

			// Restore slides to correct state
			slides.forEach( function ( slide, i ) {
				const isActive = i === current;
				slide.style.position      = isActive ? 'relative'  : 'absolute';
				slide.style.visibility    = isActive ? 'visible'   : 'hidden';
				slide.style.opacity       = isActive ? '1'         : '0';
				slide.style.pointerEvents = isActive ? 'auto'      : 'none';
			} );

			trackClip.style.height = maxH + 'px';
		}

		function goTo( index ) {
			current = Math.max( 0, Math.min( index, total - 1 ) );

			slides.forEach( function ( slide, i ) {
				slide.classList.toggle( 'is-active', i === current );
				// Clear any inline styles set by fixTrackHeight so CSS takes over
				slide.style.position      = '';
				slide.style.visibility    = '';
				slide.style.opacity       = '';
				slide.style.pointerEvents = '';
			} );

			dots.forEach( function ( dot, i ) {
				const active = i === current;
				dot.classList.toggle( 'is-active', active );
				dot.setAttribute( 'aria-selected', active ? 'true' : 'false' );
			} );

			if ( prevBtn ) prevBtn.disabled = current === 0;
			if ( nextBtn ) nextBtn.disabled = current === total - 1;

			if ( hasTilt ) {
				const incoming = slides[ current ];
				incoming.setAttribute( 'data-ts-tilt', '' );
				runTiltEntrance( incoming, targetDeg, el );
			}
		}

		if ( prevBtn ) prevBtn.addEventListener( 'click', function () { goTo( current - 1 ); } );
		if ( nextBtn ) nextBtn.addEventListener( 'click', function () { goTo( current + 1 ); } );

		dots.forEach( function ( dot, i ) {
			dot.addEventListener( 'click', function () { goTo( i ); } );
		} );

		el.addEventListener( 'keydown', function ( e ) {
			if ( e.key === 'ArrowLeft' )  goTo( current - 1 );
			if ( e.key === 'ArrowRight' ) goTo( current + 1 );
		} );

		let startX = 0;

		el.addEventListener( 'touchstart', function ( e ) {
			startX = e.touches[ 0 ].clientX;
		}, { passive: true } );

		el.addEventListener( 'touchend', function ( e ) {
			const diff = startX - e.changedTouches[ 0 ].clientX;
			if ( Math.abs( diff ) > 40 ) {
				goTo( diff > 0 ? current + 1 : current - 1 );
			}
		}, { passive: true } );

		// Debounced resize
		let resizeTimer = null;
		window.addEventListener( 'resize', function () {
			clearTimeout( resizeTimer );
			resizeTimer = setTimeout( fixTrackHeight, 150 );
		} );

		fixTrackHeight();
		goTo( 0 );
	}

	function init() {
		document.querySelectorAll( '[data-ts-slider]' ).forEach( initSlider );
	}

	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', init );
	} else {
		init();
	}
} )();